export default "__VITE_ASSET__DM6r5L3i__"